export default ['en', 'ru'];
